import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  userLogin: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.login,
      body: data
    })
  },
  userLogout: () => {
    return httpApi.postDataViaApi({
      url: api.auth.logout
    })
  },
  userSignup: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.signup,
      body: data
    })
  },
  getUserDetails: () => {
    return httpApi.getDataViaApi({
      url: api.auth.userDetails
    })
  },
  verifyEmailWithId: (query) => {
    return httpApi.getDataViaApi({
      url: api.auth.verifyEmailWithId,
      queryParams: query
    })
  },
  postResetPasswordInfo: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.resetPassword,
      body: data
    })
  },
  postForgotPasswordInfo: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.forgotPassword,
      body: data
    })
  },
  postVerifyPasswordWithId: (query) => {
    return httpApi.getDataViaApi({
      url: api.auth.verifyPasswordWithId,
      queryParams: query
    })
  },
  sendVerificationEmail: (data) => {
    return httpApi.postDataViaApi({
      url: api.auth.sendVerificationEmail,
      body: data
    })
  },
  sessionUpdate: () => {
    return httpApi.putDataViaApi({
      url: api.auth.sessionUpdate
    })
  }

}
